(function($) {

  $('.main-slider').slick({
    infinite: true,
    speed: 1400,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  $('.usecases-slider').slick({
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  $('.app-slider').slick({
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev white" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next white" aria-label="Next"></button>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          dots: true
        }
      }
    ]
  });

})(jQuery);
